import React ,{ useState, useEffect, useRef } from 'react';
import { connect,Field, reduxForm } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import * as Mail from './Saga/Mail';
import BallotIcon from '@material-ui/icons/Ballot';
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

function ListDividers(props) {
  const classes = useStyles();


 

//   const node = useRef();
const select=(mail_template_id,isDisp)=>{

  props.add_mail_templates_detail({window:window,id:mail_template_id,rentResponseId:props.responsedetail.id,isDisp:isDisp})

   props.toggleTemplateSelectClose()
}
  return (
    <List component="nav"  className={classes.root} aria-label="mailbox folders">
         <ListItem　>
         <BallotIcon/> <b >テンプレート選択</b>
        </ListItem>
        <Divider />
        {props.mail_template_select_list.map((value,key) => (
            <span key={key}>
           <ListItem　onClick={()=>select(value.id,value.isDisp)}  button>
            <ListItemText primary={value.templateName} /> <MailOutlineIcon/>
            
          </ListItem>
          <Divider />
          </span>
        ))}
      
     
   
    </List>
  );
}


const mapStateToProps = state => {
    return {
        responsedetail: state.responsesReducer.responsedetail,
        mail_template_select_list: state.mailReducer.mail_template_select_list,

    
    //     map_settings_edit: state.mapmypage.map_settings_edit,
    //     rent_introduction_headers:state.mapmypage.rent_introduction_headers,
    //     map_disp:state.mapmypage.map_disp,

    //    rent_introduction_point_headers:state.mapmypage.rent_introduction_point_headers,
        //firebasetoken: state.firebaseReducer.firebasetoken,
        //firebasedata: state.firebaseReducer.firebasedata,
    }
}
  function mapDispatchToProps(dispatch) {
    return {
        add_mypage_link(state) {
            dispatch(Mail.add_mypage_link(state))
          },
          add_mail_templates_detail(state) {
            dispatch(Mail.add_mail_templates_detail(state))
          },
          

    };
}

// App = reduxForm({
//     form: 'mapsearchform', // a unique identifier for this form
//     validate,//バリデーション
  
//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(App)
// App = withStyles(useStyles)(App);  
export default connect(mapStateToProps, mapDispatchToProps)(ListDividers);   